import type { Provenance, TtlKind, UploadSkipReason } from '@xfile/shared';
import type { MessageKey } from '../i18n';

/**
 * Correspondances valeur de contrat → CLÉ i18n (littérales, source unique).
 *
 * Le TTL et les motifs d'ignorance sont des ENUMS `@xfile/shared`. Les libellés se
 * font par table statique (jamais un template `t(\`upload.ttl.${k}\`)`) : chaque clé
 * apparaît en LITTÉRAL, donc reconnue « utilisée » par `i18n-unused-keys.test.ts` et
 * sans introduire de nouveau préfixe dynamique (le test de préfixes attend seulement
 * `lang.`/`theme.`).
 */

/** Libellé i18n d'une classe de TTL (choix d'upload + badge d'échéance des fichiers). */
export const ttlLabelKey: Record<TtlKind, MessageKey> = {
  '1d': 'upload.ttl1d',
  '1w': 'upload.ttl1w',
  '1m': 'upload.ttl1m',
  '1y': 'upload.ttl1y',
  '5y': 'upload.ttl5y',
  forever: 'upload.ttlForever',
};

/** Libellé i18n du motif d'ignorance d'un fichier refusé à l'upload. */
export const skipReasonKey: Record<UploadSkipReason, MessageKey> = {
  too_large: 'upload.reasonTooLarge',
  empty: 'upload.reasonEmpty',
  bad_name: 'upload.reasonBadName',
  write_error: 'upload.reasonWriteError',
};

/**
 * Libellé i18n de la PROVENANCE d'un fichier (`web` / `pnyx`) — badge TEXTUEL (jamais
 * l'information par la couleur seule). Source unique réutilisée par la liste des fichiers
 * de la console, la visionneuse et l'explorateur.
 */
export const provenanceLabelKey: Record<Provenance, MessageKey> = {
  web: 'community.provenanceWeb',
  pnyx: 'community.provenancePnyx',
};
